import { NavbarLogo } from './NavbarLogo';
import { NavbarProfile } from './NavbarProfile';

export function Navbar() {
  return (
    <div className="w-full flex flex-row items-center p-0 h-16 bg-background border-b border-outline">
      <div className="hidden md:hidden lg:flex justify-center lg:w-[16rem] p-[0.625rem]">
        <NavbarLogo />
      </div>
      <div className="w-full flex flex-row justify-between items-center px-[1.8125rem] gap-[1.25rem] h-16">
        <div className="w-full flex justify-end flex-row items-center p-0 gap-[2.5rem] h-[2.25rem]">
          <div>
            <NavbarProfile />
          </div>
        </div>
      </div>
    </div>
  );
}
